import { actions } from 'data'
import React, { useState } from 'react'
import { connect, ConnectedProps } from 'react-redux'

import Agreement from './Agreement'
import Amount from './Amount'
import Collateral from './Collateral'
import ItsLive from './ItsLive'
import Positions from './Positions'
import Video from './Video'

enum STEPS {
  live,
  amount,
  collateral,
  positions,
  video,
  agreement
}

type Props = ConnectedProps<typeof connector>

const MarginOnboarding = ({ enableLeverageTrading }: Props) => {
  const [step, setStep] = useState<STEPS>(STEPS.live)

  switch (step) {
    case STEPS.live:
      return <ItsLive onNext={() => setStep(STEPS.amount)} />
    case STEPS.amount:
      return <Amount onPrev={() => setStep(STEPS.live)} onNext={() => setStep(STEPS.collateral)} />
    case STEPS.collateral:
      return (
        <Collateral onNext={() => setStep(STEPS.positions)} onPrev={() => setStep(STEPS.amount)} />
      )
    case STEPS.positions:
      return (
        <Positions onNext={() => setStep(STEPS.video)} onPrev={() => setStep(STEPS.collateral)} />
      )
    case STEPS.video:
      return (
        <Video onNext={() => setStep(STEPS.agreement)} onPrev={() => setStep(STEPS.positions)} />
      )
    case STEPS.agreement:
      return <Agreement onNext={enableLeverageTrading} />
    default:
      return null
  }
}

const mapDispatchToProps = (dispatch) => ({
  enableLeverageTrading: () => {
    dispatch(actions.app.hideModal('MARGIN_ONBOARDING'))
    dispatch(actions.margin.sign())
  }
})

const connector = connect(null, mapDispatchToProps)
export default connector(MarginOnboarding)
